import { render, staticRenderFns } from "./ProfileModeForm.vue?vue&type=template&id=38b6bc23&scoped=true&"
import script from "./ProfileModeForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileModeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileModeForm.vue?vue&type=style&index=0&id=38b6bc23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6bc23",
  null
  
)

export default component.exports